import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 380,
      fontSize: 15,
      '& .ticket': {
        boxShadow: '0 0px 20px rgba(0, 0, 0, 0.09)',
        '&::before': {
          display: 'block',
          content: '" "',
          backgroundImage: 'url(/assets/ticket-effect.svg)',
          backgroundRepeat: 'repeat-x',
          backgroundPosition: 'bottom',
          height: 7,
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '&::after': {
          display: 'block',
          content: '" "',
          backgroundImage: 'url(/assets/ticket-effect.svg)',
          backgroundRepeat: 'repeat-x',
          backgroundPosition: 'bottom',
          height: 7,
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
          transform: 'rotate(180deg)',
        },
      },
    },
    header: {
      flex: 1,
      display: 'flex',
      padding: '35px 24px 10px 24px',
      '& .ticket-header-info-wrapper': {
        flex: 1,
        '& .ticket-header-info': {
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          '& .ticket-header-info-col': {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        },
        '&.has-qr-code': {
          '& .ticket-title, .ticket-number, .ticket-total': {
            textAlign: 'start',
            margin: '5px 0 0 0',
          },
          '& .ticket-total': {
            margin: '10px 0 5px 0',
          },
        },
      },
      '& .ticket-title': {
        fontSize: 14,
        textAlign: 'right',
        fontWeight: 600,
      },
      '& .ticket-number': {
        fontSize: 14,
        textAlign: 'right',
      },
      '& .ticket-status': {
        fontSize: 12,
        '& .pending': {
          color: theme.oysterTheme.pineapple,
        },
        '& .paid': {
          color: theme.oysterTheme.water,
        },
        '& .subscribed': {
          color: theme.oysterTheme.water,
        },
        '& .pendingActivation': {
          color: theme.oysterTheme.mango,
        },
      },
    },
    body: {
      '& .payee-info': {
        padding: '20px 24px 24px 20px',
        '& .payee-info-row': {
          marginBottom: 25,
          '&:last-child': {
            marginBottom: 0,
          },
        },
      },
      '& .ticket-list-collapse': {
        borderColor: theme.oysterTheme.stone,
        borderStyle: 'solid',
        borderWidth: '1px 0px 1px 0px',
        marginBottom: 100,
        '& .item-quantity': {
          fontSize: 14,
        },
      },
    },
    footer: {
      padding: '15px 24px',
      display: 'flex',
      alignItems: 'center',
      '& .ticket-date': {
        fontSize: 12,
        color: theme.oysterTheme.shark,
        display: 'flex',
        gap: '0.5em',
      },
      '& .oyster-logo': {
        height: 16,
      },
    },
    icon: {
      color: ({ secondaryColor }) => secondaryColor,
    },
    copyLinkItem: {
      '& .title': {
        fontSize: 14,
        textTransform: 'uppercase',
      },
      '& .MuiTypography-displayBlock': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    text: {
      '&.muted': {
        color: theme.oysterTheme.dolphin,
      },
    },
    price: {
      margin: 0,
      lineHeight: 1,
      '&::before': {
        width: 30,
        position: 'absolute',
        display: 'block',
        fontWeight: 400,
      },
      '&.ticket-total': {
        fontSize: 32,
        paddingLeft: 20,
        '&::before': {
          marginLeft: -20,
          fontSize: 26,
          content: '"$"',
        },
      },
      '&.item-total': {
        fontSize: 18,
        marginLeft: theme.spacing(0.5),
        '&::before': {
          marginLeft: -15,
          fontSize: 18,
        },
      },
    },
    tooltip: {
      maxWidth: 100,
      backgroundColor: theme.oysterTheme.pine,
      '& .MuiTooltip-arrow::before': {
        backgroundColor: theme.oysterTheme.pine,
      },
    },
    tooltipMessage: {
      display: 'flex',
      '& .tooltip-icon': {
        marginLeft: 5,
        alignSelf: 'center',
        width: 15,
        height: 15,
      },
    },
    markAsPaidInfo: {
      flex: 1,
      display: 'flex',
      fontSize: 12,
      textAlign: 'right',
      color: theme.oysterTheme.water,
    },
    markAsPaidIcon: {
      marginTop: 5,
      marginLeft: 5,
      height: 20,
      width: 20,
    },
  }),
);

export default useStyles;
